/**
 * lucide 图标按需注册.
 *
 * 只 import 真正用到的图标, 让 Vite 能够 tree-shake;
 * 模板里写 <i data-lucide="mic"></i>, Alpine 动态渲染出来的节点由 observeIcons() 补渲染。
 */

import {
  Bookmark,
  BookOpen,
  Captions,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  Copy,
  Ear,
  Ellipsis,
  Heart,
  Gauge,
  Search,
  House,
  KeyRound,
  Languages,
  ListMusic,
  LogIn,
  LogOut,
  Maximize,
  Mic,
  Moon,
  Pause,
  Pencil,
  Play,
  RotateCcw,
  Settings,
  ShieldCheck,
  SkipBack,
  SkipForward,
  Sun,
  Ticket,
  User,
  UserPlus,
  Volume2,
  X,
  createIcons,
} from 'lucide'

const icons = {
  Bookmark,
  BookOpen,
  Captions,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  Copy,
  Ear,
  Ellipsis,
  Heart,
  Gauge,
  Search,
  House,
  KeyRound,
  Languages,
  ListMusic,
  LogIn,
  LogOut,
  Maximize,
  Mic,
  Moon,
  Pause,
  Pencil,
  Play,
  RotateCcw,
  Settings,
  ShieldCheck,
  SkipBack,
  SkipForward,
  Sun,
  Ticket,
  User,
  UserPlus,
  Volume2,
  X,
}

export function renderIcons(root: Element | Document | DocumentFragment = document): void {
  createIcons({
    icons,
    root,
    inTemplates: true,
    attrs: { 'stroke-width': '1.75', 'aria-hidden': 'true' },
  })
}

/** 监听 DOM 变化, 为 Alpine 动态插入的节点补渲染图标 */
export function observeIcons(): void {
  let scheduled = false

  /**
   * 只认模板里的 <i data-lucide>。
   *
   * lucide 生成的 <svg> 同样带 data-lucide, 若把它也算作「新图标」, 观察器会把
   * 自己刚插入的 svg 当成新节点, 于是 renderIcons() 每帧替换一次全部 svg;
   * 光标下的图标节点被反复销毁, 点击图标本身就会丢失 click 事件
   * (点按钮边缘可以, 点图标没反应)。详见 docs/lessons-learned.md 2.7。
   */
  const isPendingIcon = (node: Node): boolean =>
    node instanceof Element &&
    (node.matches('i[data-lucide]') || node.querySelector('i[data-lucide]') !== null)

  const observer = new MutationObserver((mutations) => {
    const hasNewIcon = mutations.some((mutation) =>
      [...mutation.addedNodes].some(isPendingIcon),
    )
    if (!hasNewIcon || scheduled) return

    scheduled = true
    requestAnimationFrame(() => {
      scheduled = false
      renderIcons()
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}
